import { FSharpRef, Record, Union } from "./fable_modules/fable-library.4.10.0/Types.js";
import { getRecordField, getUnionFields, isUnion, obj_type, getRecordElements, name as name_1, option_type, array_type, list_type, unit_type, anonRecord_type, record_type, class_type, tuple_type, bool_type, string_type, int32_type, union_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { TeamModels_TeamHistoryRecord__get_AnswerReceived, SlipAnswer__ToRawString, TeamStatus, TeamModels_QuizCard__get_Msg, TourCard__SecondsLeft_7F9DDECF, Errors_SessionIsNotActive, TeamModels_TeamHistoryRecord, TourStatus, QwKey, TeamModels_QuizCard, TourCard__IsCountdownFinished_7F9DDECF, TourCard__IsCountdownActive_7F9DDECF, QuizStatus, QwKey_$reflection, TeamModels_TeamHistoryRecord_$reflection, QuizChangedEvent_$reflection, RESP$1_$reflection, TeamModels_QuizCard_$reflection } from "../shared/Shared.fs.js";
import { compare, comparePrimitives, equals, defaultOf } from "./fable_modules/fable-library.4.10.0/Util.js";
import { toList, ofList, FSharpMap__Add, empty, FSharpMap__get_Count, FSharpMap__TryGetValue } from "./fable_modules/fable-library.4.10.0/Map.js";
import { splitByLines, Infra_removeFromLocalStorage, apiCmd, batchCmd, timeoutCmd, noCmd, timeDiff as timeDiff_1, serverTime as serverTime_1 } from "./Common.fs.js";
import { unwrap, map, defaultArg } from "./fable_modules/fable-library.4.10.0/Option.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.10.0/Choice.js";
import { SimpleJson_tryParse } from "./fable_modules/Fable.SimpleJson.3.24.0/./SimpleJson.fs.js";
import { Convert_serialize, Convert_fromJson } from "./fable_modules/Fable.SimpleJson.3.24.0/./Json.Converter.fs.js";
import { createTypeInfo } from "./fable_modules/Fable.SimpleJson.3.24.0/./TypeInfo.Converter.fs.js";
import { Cmd_ofEffect, Cmd_batch } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { configure, unsubscribe as unsubscribe_1, subscribe as subscribe_1 } from "./AppSync.fs.js";
import { sortByDescending, indexed, singleton as singleton_1, empty as empty_1, map as map_1, choose, ofArray } from "./fable_modules/fable-library.4.10.0/List.js";
import { split, join, printf, toText, isNullOrEmpty } from "./fable_modules/fable-library.4.10.0/String.js";
import { tryFind } from "./fable_modules/fable-library.4.10.0/Array.js";
import * as react from "react";
import { collect, map as map_2, empty as empty_2, singleton, append, delay, toList as toList_1 } from "./fable_modules/fable-library.4.10.0/Seq.js";
import { DOMAttr, HTMLAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { mediaEl, singleTourInfo, playSounds, playFooter, resultsViewEmb, playQuiz, playTitle } from "./MainTemplates.fs.js";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";
import { Fa_IconOption, Fa_i } from "./fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { Helpers_classList } from "./fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { Internal_updateInputValue } from "./fable_modules/Fable.Elmish.React.5.0.0/./common.fs.js";
import { Icons_grin } from "./IconHelpers.fs.js";
import { toString, fromParts, compare as compare_1 } from "./fable_modules/fable-library.4.10.0/Decimal.js";

export class Tab extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["History", "Question", "Results"];
    }
}

export function Tab_$reflection() {
    return union_type("Team.Tab", [], Tab, () => [[], [], []]);
}

export class AnswersStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Input", "Sending", "Sent", "Failed"];
    }
}

export function AnswersStatus_$reflection() {
    return union_type("Team.AnswersStatus", [], AnswersStatus, () => [[], [], [], []]);
}

export class AnswersSlip extends Record {
    constructor(TourIdx, Status, Values) {
        super();
        this.TourIdx = (TourIdx | 0);
        this.Status = Status;
        this.Values = Values;
    }
}

export function AnswersSlip_$reflection() {
    return record_type("Team.AnswersSlip", [], AnswersSlip, () => [["TourIdx", int32_type], ["Status", AnswersStatus_$reflection()], ["Values", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, tuple_type(string_type, bool_type)])]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["QuizCardResp", "Exn", "Reactivate", "ChangeTab", "UpdateAnswer", "ToggleJeopardy", "CountdownTick", "QuizChanged", "AnswerResponse", "GetHistoryResp", "ConnectionErrors", "Vote", "VoteResponse"];
    }
}

export function Msg_$reflection() {
    return union_type("Team.Msg", [], Msg, () => [[["Item", RESP$1_$reflection(TeamModels_QuizCard_$reflection())]], [["Item", class_type("System.Exception")]], [], [["Item", Tab_$reflection()]], [["qwIdx", int32_type], ["txt", string_type]], [["qwIdx", int32_type]], [["Item", anonRecord_type(["QwIndex", int32_type])]], [["Item", QuizChangedEvent_$reflection()]], [["Item", RESP$1_$reflection(unit_type)]], [["Item", RESP$1_$reflection(list_type(TeamModels_TeamHistoryRecord_$reflection()))]], [["Item", array_type(string_type)]], [["qwKey", QwKey_$reflection()], ["Item2", option_type(bool_type)]], [["Item", RESP$1_$reflection(unit_type)]]]);
}

export class Model extends Record {
    constructor(IsActive, Quiz, Answers, ActiveTab, Error$, TimeDiff, History) {
        super();
        this.IsActive = IsActive;
        this.Quiz = Quiz;
        this.Answers = Answers;
        this.ActiveTab = ActiveTab;
        this.Error = Error$;
        this.TimeDiff = TimeDiff;
        this.History = History;
    }
}

export function Model_$reflection() {
    return record_type("Team.Model", [], Model, () => [["IsActive", bool_type], ["Quiz", option_type(TeamModels_QuizCard_$reflection())], ["Answers", option_type(AnswersSlip_$reflection())], ["ActiveTab", Tab_$reflection()], ["Error", string_type], ["TimeDiff", class_type("System.TimeSpan")], ["History", list_type(TeamModels_TeamHistoryRecord_$reflection())]]);
}

export function AnswersSlip__Get_Z524259A4(x, qwIdx) {
    let matchValue;
    let outArg = defaultOf();
    matchValue = [FSharpMap__TryGetValue(x.Values, qwIdx, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return ["", false];
    }
}

export function Model__get_CurrentTour(x) {
    const matchValue = x.Quiz;
    if (matchValue == null) {
        return void 0;
    }
    else {
        return matchValue.TC;
    }
}

export function Model__get_IsCountdownActive(x) {
    const matchValue = x.Quiz;
    if (matchValue == null) {
        return false;
    }
    else {
        const quiz = matchValue;
        const matchValue_1 = quiz.TC;
        if (matchValue_1 == null) {
            return false;
        }
        else {
            const qw = matchValue_1;
            if (equals(quiz.QS, new QuizStatus(1, []))) {
                return TourCard__IsCountdownActive_7F9DDECF(qw, serverTime_1(x.TimeDiff));
            }
            else {
                return false;
            }
        }
    }
}

export function error(txt, model) {
    return new Model(model.IsActive, model.Quiz, model.Answers, model.ActiveTab, txt, model.TimeDiff, model.History);
}

export function ok(model) {
    return new Model(model.IsActive, model.Quiz, model.Answers, model.ActiveTab, "", model.TimeDiff, model.History);
}

export function startup(user, quiz, serverTime, model) {
    let key, str, matchValue;
    const TimeDiff = timeDiff_1(serverTime);
    return new Model(true, quiz, defaultArg((key = awStorageKey(user), (str = localStorage.getItem(key), (matchValue = (() => {
        let matchValue_1;
        try {
            return new FSharpResult$2(0, [(matchValue_1 = SimpleJson_tryParse(str), (matchValue_1 != null) ? Convert_fromJson(matchValue_1, createTypeInfo(AnswersSlip_$reflection())) : (() => {
                throw new Error("Couldn\'t parse the input JSON string because it seems to be invalid");
            })())]);
        }
        catch (ex) {
            return new FSharpResult$2(1, [ex.message]);
        }
    })(), (matchValue.tag === 1) ? void 0 : matchValue.fields[0]))), new AnswersSlip(defaultArg(map((tour) => tour.Idx, quiz.TC), -1), (FSharpMap__get_Count(quiz.Aw) > 0) ? (new AnswersStatus(2, [])) : (new AnswersStatus(0, [])), quiz.Aw)), model.ActiveTab, model.Error, TimeDiff, model.History);
}

export function updateQuiz(f, model) {
    const matchValue = model.Quiz;
    if (matchValue == null) {
        return model;
    }
    else {
        return new Model(model.IsActive, f(matchValue), model.Answers, model.ActiveTab, model.Error, model.TimeDiff, model.History);
    }
}

export function initAnswers(model, cmd) {
    let matchValue, tour_1, matchValue_1, aw_1;
    const createAnswers = (tour, timeDiff) => (new AnswersSlip(tour.Idx, TourCard__IsCountdownFinished_7F9DDECF(tour, serverTime_1(timeDiff)) ? (new AnswersStatus(3, [])) : (new AnswersStatus(0, [])), empty({
        Compare: comparePrimitives,
    })));
    return [(matchValue = Model__get_CurrentTour(model), (matchValue == null) ? (new Model(model.IsActive, model.Quiz, void 0, model.ActiveTab, model.Error, model.TimeDiff, model.History)) : ((tour_1 = matchValue, (matchValue_1 = model.Answers, (matchValue_1 == null) ? (new Model(model.IsActive, model.Quiz, createAnswers(tour_1, model.TimeDiff), model.ActiveTab, model.Error, model.TimeDiff, model.History)) : ((matchValue_1.TourIdx !== tour_1.Idx) ? ((aw_1 = matchValue_1, new Model(model.IsActive, model.Quiz, createAnswers(tour_1, model.TimeDiff), model.ActiveTab, model.Error, model.TimeDiff, model.History))) : model))))), cmd];
}

export function setupCountdown(model, cmd) {
    let tupledArg;
    if (Model__get_IsCountdownActive(model)) {
        const matchValue_1 = Model__get_CurrentTour(model);
        tupledArg = ((matchValue_1 == null) ? noCmd(model) : [model, timeoutCmd(new Msg(6, [{
            QwIndex: matchValue_1.Idx,
        }]), 1000)]);
    }
    else {
        tupledArg = noCmd(model);
    }
    return batchCmd(cmd, tupledArg[0], tupledArg[1]);
}

export function subscribe(quizId, model, cmd) {
    const matchValue = model.Quiz;
    if (matchValue == null) {
        return [model, cmd];
    }
    else {
        const quiz = matchValue;
        return [model, Cmd_batch(ofArray([cmd, Cmd_ofEffect((dispatch) => {
            subscribe_1(quizId, quiz.LT, (arg) => {
                dispatch(new Msg(7, [arg]));
            }, (arg_1) => {
                dispatch(new Msg(10, [arg_1]));
            });
        })]))];
    }
}

export function unsubscribe(model) {
    unsubscribe_1();
}

export function applyEvent(evt, model) {
    return updateQuiz((quiz) => (new TeamModels_QuizCard(evt.QS, quiz.TS, quiz.Img, quiz.Wcm, quiz.Fwl, evt.T, quiz.Aw, quiz.LT, quiz.RT, quiz.Mxlr, evt.Url, quiz.V)), model);
}

export function answerStatus(satus, model) {
    const matchValue = model.Answers;
    if (matchValue != null) {
        const aw = matchValue;
        return new Model(model.IsActive, model.Quiz, new AnswersSlip(aw.TourIdx, satus, aw.Values), model.ActiveTab, model.Error, model.TimeDiff, model.History);
    }
    else {
        return model;
    }
}

export function answerText(qwIdx, txt, model) {
    const matchValue = model.Answers;
    let matchResult, aw_1;
    if (matchValue != null) {
        if (equals(matchValue.Status, new AnswersStatus(0, []))) {
            matchResult = 0;
            aw_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new Model(model.IsActive, model.Quiz, new AnswersSlip(aw_1.TourIdx, aw_1.Status, FSharpMap__Add(aw_1.Values, qwIdx, [txt, AnswersSlip__Get_Z524259A4(aw_1, qwIdx)[1]])), model.ActiveTab, model.Error, model.TimeDiff, model.History);
        default:
            return model;
    }
}

export function toggleJpd(qwIdx, model) {
    const matchValue = model.Answers;
    let matchResult, aw_1;
    if (matchValue != null) {
        if (equals(matchValue.Status, new AnswersStatus(0, []))) {
            matchResult = 0;
            aw_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const patternInput = AnswersSlip__Get_Z524259A4(aw_1, qwIdx);
            return new Model(model.IsActive, model.Quiz, new AnswersSlip(aw_1.TourIdx, aw_1.Status, FSharpMap__Add(aw_1.Values, qwIdx, [patternInput[0], !patternInput[1]])), model.ActiveTab, model.Error, model.TimeDiff, model.History);
        }
        default:
            return model;
    }
}

export function sendAnswer(api, model) {
    let tour;
    const matchValue_1 = model.Answers;
    let matchResult, aw_2;
    if (matchValue_1 != null) {
        if (equals(matchValue_1.Status, new AnswersStatus(0, []))) {
            matchResult = 0;
            aw_2 = matchValue_1;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_2 = Model__get_CurrentTour(model);
            let matchResult_1, tour_1;
            if (matchValue_2 != null) {
                if ((tour = matchValue_2, ((aw_2.TourIdx !== tour.Idx) ? true : (equals(tour.TS, new TourStatus(1, [])) && !TourCard__IsCountdownActive_7F9DDECF(tour, serverTime_1(model.TimeDiff)))) ? true : equals(tour.TS, new TourStatus(2, [])))) {
                    matchResult_1 = 0;
                    tour_1 = matchValue_2;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const model_1 = model;
                    const matchValue = model_1.Answers;
                    if (matchValue != null) {
                        const aw = matchValue;
                        const req = ofList(choose((tupledArg) => {
                            const _arg = tupledArg[1];
                            const txt = _arg[0];
                            if (!isNullOrEmpty(txt)) {
                                return [new QwKey(aw.TourIdx, tupledArg[0]), [txt, _arg[1]]];
                            }
                            else {
                                return void 0;
                            }
                        }, toList(aw.Values)), {
                            Compare: compare,
                        });
                        if (FSharpMap__get_Count(req) > 0) {
                            return apiCmd(api.answers, req, (Item) => (new Msg(8, [Item])), (Item_1) => (new Msg(1, [Item_1])), answerStatus(new AnswersStatus(1, []), model_1));
                        }
                        else {
                            return noCmd(answerStatus(new AnswersStatus(2, []), model_1));
                        }
                    }
                    else {
                        return noCmd(model_1);
                    }
                }
                default:
                    return noCmd(model);
            }
        }
        default:
            return noCmd(model);
    }
}

export function awStorageKey(user) {
    return toText(printf("aw-%i-%i"))(user.QuizId)(user.TeamId);
}

export function saveAnswer(user, model) {
    const matchValue = model.Answers;
    if (matchValue != null) {
        const aw = matchValue;
        const key = awStorageKey(user);
        localStorage.setItem(key, Convert_serialize(aw, createTypeInfo(AnswersSlip_$reflection())));
    }
    return model;
}

export function deleteAnswer(user, model) {
    Infra_removeFromLocalStorage(awStorageKey(user));
    return model;
}

export function updateVote(api, qwKey, vote, model) {
    return new Model(model.IsActive, model.Quiz, model.Answers, model.ActiveTab, model.Error, model.TimeDiff, map_1((r) => {
        if (equals(r.QwKey, qwKey)) {
            return new TeamModels_TeamHistoryRecord(r.QwKey, r.QwName, r.QwAw, r.AwTxt, r.AwJpd, r.Result, vote);
        }
        else {
            return r;
        }
    }, model.History));
}

export function init(api, user) {
    configure(user.AppSyncCfg.Endpoint, user.AppSyncCfg.Region, user.AppSyncCfg.ApiKey);
    return apiCmd(api.getState, void 0, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(1, [Item_1])), new Model(true, void 0, void 0, new Tab(1, []), "", 0, empty_1()));
}

export function update(api, user, msg, cm) {
    let matchResult, res_4, st, evt, qwIdx, txt_4, qwIdx_1, res_5, qwKey, vote, errors, ex_1, ex_2, txt_7;
    switch (msg.tag) {
        case 0: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 1;
                res_4 = msg.fields[0].Value.fields[0];
                st = msg.fields[0].ST;
            }
            else {
                let activePatternResult;
                const msg_1 = msg;
                const pi_1 = tryFind((pi) => (name_1(pi) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1 == null) {
                    activePatternResult = void 0;
                }
                else {
                    const pi$0027 = pi_1;
                    let msgType;
                    let copyOfStruct = msg_1;
                    msgType = Msg_$reflection();
                    if (isUnion(msgType)) {
                        const objArray = getUnionFields(msg_1, msgType)[1];
                        if (objArray.length === 1) {
                            try {
                                const patternInput_1 = getUnionFields(getRecordField(objArray[0], pi$0027), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult = ((name_1(patternInput_1[0]) === "Error") ? patternInput_1[1][0] : void 0);
                            }
                            catch (matchValue) {
                                activePatternResult = void 0;
                            }
                        }
                        else {
                            activePatternResult = void 0;
                        }
                    }
                    else {
                        activePatternResult = void 0;
                    }
                }
                if (activePatternResult != null) {
                    matchResult = 16;
                    txt_7 = activePatternResult;
                }
                else {
                    matchResult = 17;
                }
            }
            break;
        }
        case 6: {
            matchResult = 2;
            break;
        }
        case 7: {
            matchResult = 3;
            evt = msg.fields[0];
            break;
        }
        case 8: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 4;
            }
            else {
                let activePatternResult_1;
                const msg_2 = msg;
                const pi_1_1 = tryFind((pi_2) => (name_1(pi_2) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_1 == null) {
                    activePatternResult_1 = void 0;
                }
                else {
                    const pi$0027_1 = pi_1_1;
                    let msgType_1;
                    let copyOfStruct_1 = msg_2;
                    msgType_1 = Msg_$reflection();
                    if (isUnion(msgType_1)) {
                        const objArray_2 = getUnionFields(msg_2, msgType_1)[1];
                        if (objArray_2.length === 1) {
                            try {
                                const patternInput_1_1 = getUnionFields(getRecordField(objArray_2[0], pi$0027_1), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_1 = ((name_1(patternInput_1_1[0]) === "Error") ? patternInput_1_1[1][0] : void 0);
                            }
                            catch (matchValue_1) {
                                activePatternResult_1 = void 0;
                            }
                        }
                        else {
                            activePatternResult_1 = void 0;
                        }
                    }
                    else {
                        activePatternResult_1 = void 0;
                    }
                }
                if (activePatternResult_1 != null) {
                    matchResult = 16;
                    txt_7 = activePatternResult_1;
                }
                else {
                    matchResult = 17;
                }
            }
            break;
        }
        case 4: {
            matchResult = 5;
            qwIdx = msg.fields[0];
            txt_4 = msg.fields[1];
            break;
        }
        case 5: {
            matchResult = 6;
            qwIdx_1 = msg.fields[0];
            break;
        }
        case 3: {
            switch (msg.fields[0].tag) {
                case 0: {
                    matchResult = 8;
                    break;
                }
                case 2: {
                    matchResult = 9;
                    break;
                }
                default:
                    matchResult = 7;
            }
            break;
        }
        case 9: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 10;
                res_5 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_2;
                const msg_3 = msg;
                const pi_1_2 = tryFind((pi_3) => (name_1(pi_3) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_2 == null) {
                    activePatternResult_2 = void 0;
                }
                else {
                    const pi$0027_2 = pi_1_2;
                    let msgType_2;
                    let copyOfStruct_2 = msg_3;
                    msgType_2 = Msg_$reflection();
                    if (isUnion(msgType_2)) {
                        const objArray_3 = getUnionFields(msg_3, msgType_2)[1];
                        if (objArray_3.length === 1) {
                            try {
                                const patternInput_1_2 = getUnionFields(getRecordField(objArray_3[0], pi$0027_2), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_2 = ((name_1(patternInput_1_2[0]) === "Error") ? patternInput_1_2[1][0] : void 0);
                            }
                            catch (matchValue_2) {
                                activePatternResult_2 = void 0;
                            }
                        }
                        else {
                            activePatternResult_2 = void 0;
                        }
                    }
                    else {
                        activePatternResult_2 = void 0;
                    }
                }
                if (activePatternResult_2 != null) {
                    matchResult = 16;
                    txt_7 = activePatternResult_2;
                }
                else {
                    matchResult = 17;
                }
            }
            break;
        }
        case 11: {
            matchResult = 11;
            qwKey = msg.fields[0];
            vote = msg.fields[1];
            break;
        }
        case 12: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 12;
            }
            else {
                let activePatternResult_3;
                const msg_4 = msg;
                const pi_1_3 = tryFind((pi_4) => (name_1(pi_4) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_3 == null) {
                    activePatternResult_3 = void 0;
                }
                else {
                    const pi$0027_3 = pi_1_3;
                    let msgType_3;
                    let copyOfStruct_3 = msg_4;
                    msgType_3 = Msg_$reflection();
                    if (isUnion(msgType_3)) {
                        const objArray_4 = getUnionFields(msg_4, msgType_3)[1];
                        if (objArray_4.length === 1) {
                            try {
                                const patternInput_1_3 = getUnionFields(getRecordField(objArray_4[0], pi$0027_3), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_3 = ((name_1(patternInput_1_3[0]) === "Error") ? patternInput_1_3[1][0] : void 0);
                            }
                            catch (matchValue_3) {
                                activePatternResult_3 = void 0;
                            }
                        }
                        else {
                            activePatternResult_3 = void 0;
                        }
                    }
                    else {
                        activePatternResult_3 = void 0;
                    }
                }
                if (activePatternResult_3 != null) {
                    matchResult = 16;
                    txt_7 = activePatternResult_3;
                }
                else {
                    matchResult = 17;
                }
            }
            break;
        }
        case 10: {
            matchResult = 13;
            errors = msg.fields[0];
            break;
        }
        case 1: {
            if (msg.fields[0].message === Errors_SessionIsNotActive) {
                matchResult = 14;
                ex_1 = msg.fields[0];
            }
            else {
                matchResult = 15;
                ex_2 = msg.fields[0];
            }
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return apiCmd(api.takeActiveSession, void 0, (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(1, [Item_1])), cm);
        case 1: {
            let tupledArg_2;
            let tupledArg_1;
            const tupledArg = sendAnswer(api, ok(startup(user, res_4, st, cm)));
            tupledArg_1 = subscribe(user.QuizId, tupledArg[0], tupledArg[1]);
            tupledArg_2 = initAnswers(tupledArg_1[0], tupledArg_1[1]);
            return setupCountdown(tupledArg_2[0], tupledArg_2[1]);
        }
        case 2: {
            const tupledArg_3 = sendAnswer(api, cm);
            return setupCountdown(tupledArg_3[0], tupledArg_3[1]);
        }
        case 3: {
            let tupledArg_5;
            const tupledArg_4 = sendAnswer(api, applyEvent(evt, cm));
            tupledArg_5 = initAnswers(tupledArg_4[0], tupledArg_4[1]);
            return setupCountdown(tupledArg_5[0], tupledArg_5[1]);
        }
        case 4:
            return noCmd(ok(answerStatus(new AnswersStatus(2, []), deleteAnswer(user, cm))));
        case 5:
            return noCmd(saveAnswer(user, answerText(qwIdx, txt_4, cm)));
        case 6:
            return noCmd(saveAnswer(user, toggleJpd(qwIdx_1, cm)));
        case 7:
            return noCmd(new Model(cm.IsActive, cm.Quiz, cm.Answers, new Tab(1, []), cm.Error, cm.TimeDiff, cm.History));
        case 8:
            return apiCmd(api.getHistory, void 0, (Item_2) => (new Msg(9, [Item_2])), (Item_3) => (new Msg(1, [Item_3])), new Model(cm.IsActive, cm.Quiz, cm.Answers, new Tab(0, []), cm.Error, cm.TimeDiff, cm.History));
        case 9:
            return noCmd(new Model(cm.IsActive, cm.Quiz, cm.Answers, new Tab(2, []), cm.Error, cm.TimeDiff, cm.History));
        case 10:
            return noCmd(new Model(cm.IsActive, cm.Quiz, cm.Answers, cm.ActiveTab, cm.Error, cm.TimeDiff, res_5));
        case 11:
            return apiCmd(api.vote, {
                Key: qwKey,
                Vote: unwrap(vote),
            }, (Item_4) => (new Msg(12, [Item_4])), (Item_5) => (new Msg(1, [Item_5])), updateVote(api, qwKey, vote, cm));
        case 12:
            return noCmd(cm);
        case 13:
            return noCmd(error(join("/", errors), cm));
        case 14: {
            unsubscribe(cm);
            return noCmd(new Model(false, cm.Quiz, cm.Answers, cm.ActiveTab, cm.Error, cm.TimeDiff, cm.History));
        }
        case 15:
            return noCmd(error(ex_2.message, cm));
        case 16:
            return noCmd(error(txt_7, cm));
        default:
            return noCmd(cm);
    }
}

export function view(dispatch, user, settings, model, l10n) {
    if (model.IsActive) {
        const matchValue_1 = model.Quiz;
        if (matchValue_1 == null) {
            return model.Error;
        }
        else {
            return activeView(dispatch, user, settings, matchValue_1, model, l10n);
        }
    }
    else {
        return notActiveView(dispatch, user, model.Error, l10n);
    }
}

export function notActiveView(dispatch, user, error_1, l10n) {
    let children_14, children_12;
    const children_16 = [(children_14 = [(children_12 = [react.createElement("p", {
        className: "title",
    }, l10n.NotActive), react.createElement("p", {
        className: "title",
    }, user.QuizName), react.createElement("p", {
        className: "subtitle",
    }, user.TeamName), react.createElement("p", {
        className: "subtitle",
    }, l10n.AnotherSession), react.createElement("a", {
        className: "button is-large",
        onClick: (_arg) => {
            dispatch(new Msg(2, []));
        },
    }, l10n.UseThisDevice), react.createElement("p", {
        className: "help is-white",
    }, error_1)], react.createElement("div", {
        className: "container has-text-centered is-fluid",
    }, ...children_12))], react.createElement("div", {
        className: "hero-body",
    }, ...children_14))];
    return react.createElement("section", {
        className: "hero is-danger is-medium is-fullheight",
    }, ...children_16);
}

export function activeView(dispatch, user, settings, quiz, model, l10n) {
    let props_18, children_18;
    const serverTime = serverTime_1(model.TimeDiff);
    let patternInput;
    const matchValue = quiz.TC;
    if (matchValue == null) {
        patternInput = [0, false, false];
    }
    else {
        const tour = matchValue;
        patternInput = [TourCard__SecondsLeft_7F9DDECF(tour, serverTime), TourCard__IsCountdownActive_7F9DDECF(tour, serverTime), TourCard__IsCountdownFinished_7F9DDECF(tour, serverTime)];
    }
    const secondsLeft = patternInput[0] | 0;
    const isCountdownActive = patternInput[1];
    const props_20 = [["style", {
        width: "100%",
        height: "100%",
        minWidth: "375px",
        textAlign: "center",
        position: "relative",
    }]];
    const children_20 = [(props_18 = [["style", {
        overflowY: "auto",
        position: "absolute",
        top: "0",
        width: "100%",
    }]], (children_18 = toList_1(delay(() => {
        let props_12, children_12;
        return append(singleton((props_12 = [new HTMLAttr(65, ["container"]), ["style", {
            maxWidth: "800px",
        }]], (children_12 = toList_1(delay(() => append(singleton(playTitle(settings.MediaHost, quiz.Img, quiz.Mxlr, quiz.Url)), delay(() => append(singleton(react.createElement("h3", {
            className: "title is-3",
        }, user.QuizName)), delay(() => append(singleton(react.createElement("h4", {
            className: "subtitle is-4",
        }, user.TeamName)), delay(() => {
            let children_6, children_10;
            const matchValue_1 = quiz.TS;
            return (matchValue_1.tag === 1) ? singleton((children_6 = toList_1(delay(() => {
                const matchValue_2 = model.ActiveTab;
                switch (matchValue_2.tag) {
                    case 1: {
                        const matchValue_4 = model.Answers;
                        let matchResult;
                        if (quiz.QS.tag === 1) {
                            if (matchValue_4 != null) {
                                matchResult = 0;
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                        switch (matchResult) {
                            case 0:
                                return singleton(quiestionView(dispatch, settings, quiz, matchValue_4, isCountdownActive, patternInput[2], l10n));
                            default:
                                return singleton(playQuiz(quiz.QS, TeamModels_QuizCard__get_Msg(quiz), l10n.Common));
                        }
                    }
                    case 2:
                        return singleton(resultsViewEmb(user.QuizId)(quiz.RT)(user.TeamId)(settings.MediaHost));
                    default:
                        return singleton(historyView(dispatch, model, l10n));
                }
            })), react.createElement("div", {}, ...children_6))) : ((matchValue_1.tag === 2) ? singleton((children_10 = [react.createElement("span", {
                className: "has-text-danger has-text-weight-bold",
            }, l10n.RegistrationHasBeenRejected)], react.createElement("div", {
                className: "notification is-white",
            }, ...children_10))) : singleton(react.createElement("div", {
                className: "notification is-white",
            }, l10n.WaitingForConfirmation)));
        })))))))), react.createElement("div", keyValueList(props_12, 1), ...children_12)))), delay(() => append(singleton(react.createElement("p", {
            className: "help is-danger",
        }, model.Error)), delay(() => {
            let props_16;
            return append(singleton((props_16 = [["style", {
                height: "66px",
            }]], react.createElement("div", keyValueList(props_16, 1)))), delay(() => (equals(quiz.TS, new TeamStatus(1, [])) ? append(singleton(playFooter((arg) => {
                dispatch(new Msg(3, [arg]));
            }, new Tab(0, []), new Tab(1, []), new Tab(2, []), model.ActiveTab, isCountdownActive, secondsLeft, l10n.Common)), delay(() => {
                playSounds(settings.MediaHost, secondsLeft);
                return empty_2();
            })) : empty_2())));
        }))));
    })), react.createElement("div", keyValueList(props_18, 1), ...children_18)))];
    return react.createElement("div", keyValueList(props_20, 1), ...children_20);
}

export function quiestionView(dispatch, settings, quiz, answers, isCountdownActive, isCountdownFinished, l10n) {
    const children = toList_1(delay(() => {
        const matchValue = quiz.TC;
        if (matchValue == null) {
            return empty_2();
        }
        else {
            const tour = matchValue;
            const matchValue_1 = tour.Slip;
            return (matchValue_1.tag === 1) ? singleton(multipleQwView(dispatch, settings, tour, matchValue_1.fields[0], matchValue_1.fields[1], answers, isCountdownFinished, l10n)) : singleton(singleQwView(dispatch, settings, tour, matchValue_1.fields[0], answers, isCountdownActive, isCountdownFinished, l10n));
        }
    }));
    return react.createElement("div", {}, ...children);
}

export function answerStatusIcon(status, txt) {
    const children = [Fa_i(toList_1(delay(() => ((status.tag === 1) ? singleton(new Fa_IconOption(11, ["fas fa-spinner"])) : ((status.tag === 2) ? (isNullOrEmpty(txt) ? singleton(new Fa_IconOption(11, ["fas fa-exclamation"])) : singleton(new Fa_IconOption(11, ["fas fa-check"]))) : ((status.tag === 3) ? singleton(new Fa_IconOption(11, ["fas fa-exclamation"])) : singleton(new Fa_IconOption(11, ["fas fa-question"]))))))), [])];
    return react.createElement("span", {
        className: "icon is-large is-right has-text-black",
    }, ...children);
}

export function jeopardyControl(dispatch, jpd, readOnly, l10n) {
    let props_2, children_2, children;
    const children_4 = [(props_2 = [Helpers_classList([["button", true], ["has-text-grey-light", !jpd], ["has-text-danger", jpd]]), new HTMLAttr(158, [l10n.Jeopardy]), new HTMLAttr(132, [readOnly]), new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(5, [0]));
    }])], (children_2 = [(children = [Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-paw"])), []), " " + l10n.Jeopardy], react.createElement("span", {}, ...children))], react.createElement("a", keyValueList(props_2, 1), ...children_2)))];
    return react.createElement("p", {
        className: "control",
    }, ...children_4);
}

export function awArea(dispatch, aw, jpd, status, withChoice, readOnly, l10n) {
    const children_2 = toList_1(delay(() => append(withChoice ? singleton(jeopardyControl(dispatch, jpd, readOnly, l10n)) : empty_2(), delay(() => append(singleton(react.createElement("textarea", {
        className: "textarea",
        maxLength: 64,
        readOnly: readOnly,
        ref: (e) => {
            Internal_updateInputValue(aw, e);
        },
        onChange: (ev) => {
            dispatch(new Msg(4, [0, ev.target.value]));
        },
    })), delay(() => singleton(answerStatusIcon(status, aw))))))));
    return react.createElement("div", {
        className: "control has-icons-right",
    }, ...children_2);
}

export function singleQwView(dispatch, settings, tour, slip, answers, isCountdownActive, isCountdownFinished, l10n) {
    const children_30 = toList_1(delay(() => append(singleton(singleTourInfo(settings.MediaHost, tour.Name, slip, l10n.Common)), delay(() => {
        const patternInput = AnswersSlip__Get_Z524259A4(answers, 0);
        const txt = patternInput[0];
        const jpd = patternInput[1];
        const matchValue = slip;
        switch (matchValue.tag) {
            case 1: {
                const slip_1 = matchValue.fields[0];
                return (isCountdownActive ? true : isCountdownFinished) ? append(singleton(react.createElement("label", {
                    className: "label",
                }, l10n.YourAnswer)), delay(() => {
                    const matchValue_1 = slip_1.Choices;
                    if (matchValue_1 != null) {
                        const list = matchValue_1;
                        return append(slip_1.Ch ? singleton(jeopardyControl(dispatch, jpd, isCountdownFinished, l10n)) : empty_2(), delay(() => append(singleton(react.createElement("br", {})), delay(() => {
                            let children_12, children_10, children_8;
                            return singleton((children_12 = [(children_10 = [(children_8 = toList_1(delay(() => map_2((ch) => {
                                let children_4;
                                const children_6 = [(children_4 = toList_1(delay(() => {
                                    let props_4;
                                    return append(singleton((props_4 = [Helpers_classList([["button", true], ["is-fullwidth", true], ["is-info", txt === ch]]), new DOMAttr(40, [(_arg) => {
                                        dispatch(new Msg(4, [0, ch]));
                                    }])], react.createElement("a", keyValueList(props_4, 1), ch))), delay(() => ((txt === ch) ? singleton(answerStatusIcon(answers.Status, txt)) : empty_2())));
                                })), react.createElement("div", {
                                    className: "control has-icons-left has-icons-right",
                                }, ...children_4)), react.createElement("br", {})];
                                return react.createElement("li", {}, ...children_6);
                            }, list))), react.createElement("ul", {}, ...children_8))], react.createElement("div", {
                                className: "column is-half mx-3",
                            }, ...children_10))], react.createElement("div", {
                                className: "columns is-centered",
                            }, ...children_12)));
                        }))));
                    }
                    else {
                        return singleton(awArea(dispatch, txt, jpd, answers.Status, slip_1.Ch, isCountdownFinished, l10n));
                    }
                })) : empty_2();
            }
            case 2: {
                const slip_2 = matchValue.fields[0];
                const matchValue_2 = slip_2.Aw;
                return (matchValue_2.tag === 1) ? append(slip_2.Ch ? singleton(jeopardyControl(dispatch, jpd, true, l10n)) : empty_2(), delay(() => append(singleton(react.createElement("br", {})), delay(() => {
                    let children_28, children_26, children_24;
                    return singleton((children_28 = [(children_26 = [(children_24 = toList_1(delay(() => map_2((ch_1) => {
                        let children_20;
                        const children_22 = [(children_20 = toList_1(delay(() => {
                            let props_22;
                            return append(singleton((props_22 = [Helpers_classList([["button", true], ["is-fullwidth", true], ["is-success", ch_1.IsCorrect && (txt === ch_1.Text)], ["is-danger", !ch_1.IsCorrect && (txt === ch_1.Text)]])], react.createElement("a", keyValueList(props_22, 1), ch_1.Text))), delay(() => {
                                let children_18;
                                return append(ch_1.IsCorrect ? singleton((children_18 = [Fa_i(singleton_1(Icons_grin), [])], react.createElement("span", {
                                    className: "icon is-large is-left has-text-black",
                                }, ...children_18))) : empty_2(), delay(() => ((txt === ch_1.Text) ? singleton(answerStatusIcon(answers.Status, txt)) : empty_2())));
                            }));
                        })), react.createElement("div", {
                            className: "control has-icons-left has-icons-right",
                        }, ...children_20)), react.createElement("br", {})];
                        return react.createElement("li", {}, ...children_22);
                    }, matchValue_2.fields[0]))), react.createElement("ul", {}, ...children_24))], react.createElement("div", {
                        className: "column is-half mx-3",
                    }, ...children_26))], react.createElement("div", {
                        className: "columns is-centered",
                    }, ...children_28)));
                })))) : append(singleton(react.createElement("label", {
                    className: "label",
                }, l10n.YourAnswer)), delay(() => singleton(awArea(dispatch, txt, jpd, answers.Status, slip_2.Ch, true, l10n))));
            }
            default: {
                return empty_2();
            }
        }
    }))));
    return react.createElement("div", {}, ...children_30);
}

export function awInput(dispatch, idx, aw, jpd, status, withChoice, readOnly, l10n) {
    let children_6;
    const props_10 = [["style", {
        maxWidth: "320px",
        display: "inline-block",
    }]];
    const children_8 = [(children_6 = toList_1(delay(() => {
        let children_2, props, children;
        return append(withChoice ? singleton((children_2 = [(props = [Helpers_classList([["button", true], ["has-text-grey-light", !jpd], ["has-text-danger", jpd]]), new HTMLAttr(158, [l10n.Jeopardy]), new HTMLAttr(132, [readOnly]), new DOMAttr(40, [(_arg) => {
            dispatch(new Msg(5, [idx]));
        }])], (children = [Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-paw"])), [])], react.createElement("a", keyValueList(props, 1), ...children)))], react.createElement("p", {
            className: "control",
        }, ...children_2))) : empty_2(), delay(() => {
            let children_4;
            return singleton((children_4 = [react.createElement("input", {
                className: "input",
                type: "text",
                maxLength: 64,
                placeholder: l10n.YourAnswer,
                readOnly: readOnly,
                ref: (e) => {
                    Internal_updateInputValue(aw, e);
                },
                onChange: (ev) => {
                    dispatch(new Msg(4, [idx, ev.target.value]));
                },
            }), answerStatusIcon(status, aw)], react.createElement("p", {
                className: "control has-icons-right",
            }, ...children_4)));
        }));
    })), react.createElement("div", {
        className: "field has-addons",
    }, ...children_6))];
    return react.createElement("div", keyValueList(props_10, 1), ...children_8);
}

export function multipleQwView(dispatch, settings, tour, name, slips, answers, isCountdownFinished, l10n) {
    const children_12 = toList_1(delay(() => append(singleton(react.createElement("h5", {
        className: "subtitle is-5",
    }, name)), delay(() => collect((matchValue) => {
        let children_6, arg_5, children_2, arg_2;
        const idx = matchValue[0] | 0;
        const patternInput = AnswersSlip__Get_Z524259A4(answers, idx);
        const jpd = patternInput[1];
        const aw = patternInput[0];
        const matchValue_1 = matchValue[1];
        switch (matchValue_1.tag) {
            case 2: {
                const slip_2 = matchValue_1.fields[0];
                return append(singleton((children_6 = [(arg_5 = ((idx + 1) | 0), toText(printf("%s %s.%i"))(l10n.Question)(tour.Name)(arg_5))], react.createElement("p", {
                    className: "has-text-weight-semibold",
                }, ...children_6))), delay(() => append(singleton(awInput(dispatch, idx, aw, jpd, answers.Status, slip_2.Ch, isCountdownFinished, l10n)), delay(() => {
                    let children_8;
                    return append(singleton((children_8 = [l10n.CorrectAnswer + ": ", split(SlipAnswer__ToRawString(slip_2.Aw), ["\n"], void 0, 0)[0]], react.createElement("p", {
                        className: "has-text-weight-light is-family-secondary is-size-6",
                    }, ...children_8))), delay(() => append(mediaEl(settings.MediaHost, slip_2.Media, true), delay(() => {
                        let children_10;
                        return append(singleton((children_10 = splitByLines(slip_2.Com), react.createElement("p", {
                            className: "is-italic has-text-weight-light is-family-secondary is-size-7",
                        }, ...children_10))), delay(() => singleton(react.createElement("br", {}))));
                    }))));
                }))));
            }
            case 0:
                return singleton("x3");
            default: {
                const slip_1 = matchValue_1.fields[0];
                return append(singleton((children_2 = [(arg_2 = ((idx + 1) | 0), toText(printf("%s %s.%i"))(l10n.Question)(tour.Name)(arg_2))], react.createElement("p", {
                    className: "has-text-weight-semibold",
                }, ...children_2))), delay(() => append(mediaEl(settings.MediaHost, slip_1.Media, true), delay(() => {
                    let children_4;
                    return append(singleton((children_4 = splitByLines(slip_1.Txt), react.createElement("p", {}, ...children_4))), delay(() => append(singleton(awInput(dispatch, idx, aw, jpd, answers.Status, slip_1.Ch, isCountdownFinished, l10n)), delay(() => append(singleton(react.createElement("br", {})), delay(() => singleton(react.createElement("br", {}))))))));
                }))));
            }
        }
    }, indexed(slips))))));
    return react.createElement("div", {}, ...children_12);
}

export function historyView(dispatch, model, l10n) {
    let children_10, children_8, props, props_2, props_6, children_44;
    const children_46 = [(children_10 = [(children_8 = [(props = [["style", {
        width: "30px",
    }]], react.createElement("th", keyValueList(props, 1), "#")), (props_2 = [["style", {
        textAlign: "left",
    }]], react.createElement("th", keyValueList(props_2, 1), l10n.Answer)), react.createElement("th", {}, l10n.Points), (props_6 = [new HTMLAttr(158, [l10n.Vote]), ["style", {
        width: "84px",
    }]], react.createElement("th", keyValueList(props_6, 1), "@"))], react.createElement("tr", {}, ...children_8))], react.createElement("thead", {}, ...children_10)), (children_44 = toList_1(delay(() => collect((aw) => {
        let v_1, children_34, children_14, props_12, props_18, children_18, props_16, children_16, children_22, children_32;
        let modifiers;
        const matchValue = aw.Result;
        modifiers = ((matchValue == null) ? empty_1() : ((compare_1(matchValue, fromParts(0, 0, 0, false, 0)) > 0) ? ((v_1 = matchValue, singleton_1(["has-text-success", true]))) : singleton_1(["has-text-danger", true])));
        return append(singleton((children_34 = [(children_14 = [(props_12 = [Helpers_classList(modifiers)], react.createElement("p", keyValueList(props_12, 1), aw.QwName))], react.createElement("td", {}, ...children_14)), (props_18 = [["style", {
            textAlign: "left",
        }]], (children_18 = [(props_16 = [Helpers_classList(modifiers)], (children_16 = toList_1(delay(() => append(aw.AwJpd ? singleton(Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-paw"]), new Fa_IconOption(3, [])]), [])) : empty_2(), delay(() => singleton(defaultArg(aw.AwTxt, "")))))), react.createElement("p", keyValueList(props_16, 1), ...children_16)))], react.createElement("td", keyValueList(props_18, 1), ...children_18))), (children_22 = toList_1(delay(() => {
            let d_1, d_2, props_20;
            let txt;
            const matchValue_1 = aw.Result;
            txt = ((matchValue_1 == null) ? "" : ((compare_1(matchValue_1, fromParts(0, 0, 0, false, 0)) > 0) ? ((d_1 = matchValue_1, toText(printf("+%M"))(d_1))) : ((d_2 = matchValue_1, toString(d_2)))));
            return singleton((props_20 = [Helpers_classList(modifiers)], react.createElement("p", keyValueList(props_20, 1), txt)));
        })), react.createElement("td", {}, ...children_22)), (children_32 = toList_1(delay(() => {
            let children_26, props_24, children_24;
            if (TeamModels_TeamHistoryRecord__get_AnswerReceived(aw)) {
                const isUpSelected = defaultArg(aw.Vote, false);
                const isDownSelected = !defaultArg(aw.Vote, true);
                return append(singleton((children_26 = [(props_24 = [new HTMLAttr(65, ["icon " + (isUpSelected ? "has-text-success" : "has-text-grey")])], (children_24 = [Fa_i(singleton_1(new Fa_IconOption(11, ["far fa-thumbs-up"])), [])], react.createElement("span", keyValueList(props_24, 1), ...children_24)))], react.createElement("button", {
                    className: "button is-small is-white",
                    onClick: (_arg) => {
                        dispatch(new Msg(11, [aw.QwKey, isUpSelected ? void 0 : true]));
                    },
                }, ...children_26))), delay(() => {
                    let children_30, props_28, children_28;
                    return singleton((children_30 = [(props_28 = [new HTMLAttr(65, ["icon " + (isDownSelected ? "has-text-danger" : "has-text-grey")])], (children_28 = [Fa_i(singleton_1(new Fa_IconOption(11, ["far fa-thumbs-down"])), [])], react.createElement("span", keyValueList(props_28, 1), ...children_28)))], react.createElement("button", {
                        className: "button is-small is-white",
                        onClick: (_arg_1) => {
                            dispatch(new Msg(11, [aw.QwKey, isDownSelected && void 0]));
                        },
                    }, ...children_30)));
                }));
            }
            else {
                return empty_2();
            }
        })), react.createElement("td", {}, ...children_32))], react.createElement("tr", {}, ...children_34))), delay(() => {
            let children_42, props_40, children_40, children_38;
            return (aw.QwAw !== "") ? singleton((children_42 = [react.createElement("td", {}), (props_40 = [new HTMLAttr(67, [3]), ["style", {
                textAlign: "left",
            }]], (children_40 = [(children_38 = [l10n.CorrectAnswer + ": ", split(aw.QwAw, ["\n"], void 0, 0)[0]], react.createElement("span", {
                className: "is-italic has-text-weight-light is-family-secondary is-size-7",
            }, ...children_38))], react.createElement("td", keyValueList(props_40, 1), ...children_40)))], react.createElement("tr", {}, ...children_42))) : empty_2();
        }));
    }, sortByDescending((aw_1) => aw_1.QwKey, model.History, {
        Compare: compare,
    })))), react.createElement("tbody", {}, ...children_44))];
    return react.createElement("table", {
        className: "table is-hoverable is-fullwidth",
    }, ...children_46);
}

